import { gql } from "@apollo/client";

const DEPLOY_BOT = gql`
  mutation DeployBot($input: DeployBotInput!) {
    deployBot(input: $input) {
      success
      error
      deployment {
        id
        deploymentId
        botId
        channelType
        channelId
        channelName
        vectorNamespace
        enabled
        widgetConfig
        totalConversations
        totalHandoffs
        avgConfidenceScore
        createdAt
        updatedAt
      }
    }
  }
`;

export default DEPLOY_BOT;
